import React, { useState } from "react";
import "./ChargeTools.css";

type Props = {
  disabled: boolean;
  onAdd: (amount_cents: number, merchant: string) => Promise<void>;
};

const PRESETS: { label: string; cents: number; merchant: string; emoji: string }[] = [
  { label: "Coffee", cents: 525, merchant: "Coffee", emoji: "☕" },
  { label: "Snack", cents: 350, merchant: "Snack", emoji: "🍫" },
  { label: "Lunch", cents: 1800, merchant: "Lunch", emoji: "🥪" },
  { label: "Drinks", cents: 2200, merchant: "Drinks", emoji: "🍻" },
  { label: "Dinner", cents: 4200, merchant: "Dinner", emoji: "🍝" },
  { label: "Uber", cents: 1850, merchant: "Rideshare", emoji: "🚕" },
  { label: "Groceries", cents: 7500, merchant: "Groceries", emoji: "🛒" },
  { label: "Big buy", cents: 14999, merchant: "Big buy", emoji: "💳" },
];

export default function ChargeTools({ disabled, onAdd }: Props) {
  const [amount, setAmount] = useState("10.00");
  const [merchant, setMerchant] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fire = async (cents: number, m: string) => {
    setError(null);
    setBusy(true);
    try {
      await onAdd(cents, m);
    } catch (e: any) {
      setError(e.message || String(e));
    } finally {
      setBusy(false);
    }
  };

  const fireCustom = async () => {
    const dollars = parseFloat(amount);
    if (!isFinite(dollars) || dollars <= 0) {
      setError("amount must be > 0");
      return;
    }
    await fire(Math.round(dollars * 100), merchant || "manual");
  };

  return (
    <div className="panel">
      <div className="panel-title">testing tools</div>

      <div className="preset-grid">
        {PRESETS.map((p) => (
          <button
            key={p.label}
            className="preset-btn"
            disabled={disabled || busy}
            onClick={() => fire(p.cents, p.merchant)}
            title={`$${(p.cents / 100).toFixed(2)}`}
          >
            <span className="preset-emoji">{p.emoji}</span>
            <span className="preset-label">{p.label}</span>
            <span className="preset-amount">${(p.cents / 100).toFixed(2)}</span>
          </button>
        ))}
      </div>

      <div className="custom-charge">
        <div className="money-input small">
          <span>$</span>
          <input
            type="number"
            step="0.01"
            min="0"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
          />
        </div>
        <input
          className="merchant-input"
          type="text"
          placeholder="merchant"
          value={merchant}
          onChange={(e) => setMerchant(e.target.value)}
        />
        <button
          className="fire-btn"
          disabled={disabled || busy}
          onClick={fireCustom}
        >
          fire charge
        </button>
      </div>

      {error ? <div className="control-error">{error}</div> : null}
    </div>
  );
}
